/** Created by azhou on 2019/4/2.*/
<template>
    <div>
      <public-title :showBack="Boolean(queryCon.GST)">
        {{userInfo.type == 2 ? '积分明细' : '排行榜'}}
      </public-title>
      <div class="load-area">
        <el-tabs v-model="activeName" @tab-click="getLists">
          <el-tab-pane :label="item.name" :name="item.value" v-for="item in tabArr" :key="item.allhotels"/>
        </el-tabs>
        <!-- <ul class="list-head mt-4" v-if="activeName!=='activedetails'">
          <li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li>
        </ul> -->
        <ul class="list-head mt-4" v-if="showHead&&(activeName=='allhotels'||activeName=='subsidiaryhotels')">
          <li :class="item=='名称'?'w-100':'w-20'" v-for="item in titleArr" :key="item">{{item}}</li>
        </ul>
        <!--全部酒店-->
        <div v-if="activeName==='allhotels'">
          <itemize-rank v-for="(item,index) in RankList" :key="index" :Itemize="item" :Index="index"/>
        </div>
        <!--旗下酒店-->
        <div v-if="activeName==='subsidiaryhotels'">
          <itemize-rank v-for="(item,index) in RankList" :key="index" :Itemize="item" :Index="index"/>
        </div>
        <div v-if="activeName == '积分明细' && isGroup && !queryCon.GST">
          <group-credit />
        </div>
        <div v-if="activeName=='activedetails'">
          <itemize-credit/>
        </div>
        <!--集团活跃明细-->
        <!-- <div v-if="activeName == 'activedetails'&&isGroup&&!queryCon.store">
          <GroupRoomList :activeName="activeName"></GroupRoomList>
        </div> -->
        <!--等级规则-->
        <rank-rules v-if="activeName==='levelrules'"/>
        <!-- <exclusive-privilege v-if="activeName==='等级规则'"/> -->
        <exclusive-privilege v-if="activeName==='pointsrules'"/>
      </div>
    </div>
</template>

<script>
  import { mapGetters, mapActions,mapState } from 'vuex'
  import ItemizeRank from './ItemizeRank'
  import ItemizeCredit from './ItemizeCredit'
  import RankRules from './RankRules'
  import ExclusivePrivilege from './ExclusivePrivilege'
  import GroupCredit from './GroupCredit'
  import GroupRoomList from './GroupRoomList.vue'
  export default {
    name: 'Index',
    components: { ExclusivePrivilege, RankRules, ItemizeCredit, ItemizeRank, GroupCredit,GroupRoomList},
    computed: {
      ...mapState(['CreditList','userLoginMessage']),
      ...mapGetters(['userInfo','storeInfo','isGroup']),
      queryCon() { return this.$route.query },
      tabArr() {
          switch (this.userInfo.type) {
            case 2:
              return [
                {name: '积分明细', value: 'activedetails'},
                {name: '积分规则', value: 'pointsrules'}
              ]
            default: 
              let earr = [
                {name: '活跃明细', value: 'activedetails'},
                {name: '等级规则', value: 'levelrules'},
                {name: '全部酒店', value: 'allhotels'},
              ]
              if (!this.isGroup) {earr.splice(3,1);earr[2].name='排行榜';}// earr.push({name: '旗下酒店', value: 'subsidiaryhotels'})
              return earr
          }
      },
      titleArr() {
        switch (this.activeName) {
          case '活跃等级':
          case 'allhotels': 
          case 'subsidiaryhotels': 
            let arr = ['排名','名称','等级','标识','活跃值','门店认证']
            if (this.activeName == '活跃等级') arr.push('操作')
            return arr;
          case 'activedetails':
            return ['订单号','时间','积分变动','类型'];
          default:return []
        }
      },
      showHead() {
        if (this.isGroup) {
          if (this.userInfo.type == 2 && this.queryCon.GST) return true
          if (this.userInfo.type != 2) return true
        } else {return true}
      }
    },
    data() {
      return {
        activeName:'allhotels',
        RankList:[],
        total: 0,
        page: 1
      }
    },
    watch:{
        queryCon(newVal) {
          if(newVal.tab){
            this.activeName = newVal.tab;
            this.getLists();
          }
        },
    },
    created() {
      let activeName=this.userInfo.type===3?'allhotels':'activedetails'
      this.activeName = this.queryCon.tab || activeName;
      this.getLists();
    },
    methods:{
      rankIndex (index) {
        return this.page > 1 ? (index + (20 * (this.page-1))) : index
      },
      async getLists() {
        if(this.queryCon.tab!== this.activeName){
          this.$router.replace({name:this.$route.name,query:{...this.queryCon,tab:this.activeName}})
        }
        let res = {}
        switch (this.activeName) {
          case 'allhotels':
          case 'subsidiaryhotels':
            let data = {}
            let url=this.activeName==='subsidiaryhotels' ? '/pc/Common/GroupHotelRanking' : '/pc/Common/HotelRanking'
            if (this.isGroup) {data.store_id=this.storeInfo.grostoreId}//delete data.store_id; store_id: this.isGroup ? this.storeInfo.grostoreId :this.storeInfo.storeId
            res = await this.$axios.post(url,data);
            if (res.code === '00000' || res.code === '99999') {
              this.RankList = res.data.list || [];
              if (this.isGroup) this.total = res.data.count
            }
            break;
        }
      }
    }
  }
</script>
